import { isVwfs as getIsVwfs } from '../Components/FinancingCalculator/Helpers/FinanceMap';

export const getValueFormatterForProduct = (captiveId: string) => (value: number) => {
  const isVwfs = getIsVwfs(captiveId);

  if (!isVwfs) {
    return value;
  }

  return Math.ceil(value);
};
